import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { AlertProvider } from "./components/alerts";
import "./index.css";
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // O placar e as submissoes chegam por SSE; refetch por foco so duplica
      // trabalho. A ressincronizacao acontece na reconexao do EventSource.
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("elemento #root nao encontrado");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AlertProvider>
          <App />
        </AlertProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
